// Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const RESET_CART = 'reset_cart'; /* e.g. on Logout */
export const EMPTY_CART = 'empty_cart';      /* e.g. on place order */
export const RESTORE_CART = 'restore_cart';  /* e.g. via api */
export const SET_DISPENSARY = 'set_dispensary';
export const SET_DISPENSARIES = 'set_dispensaries';
export const SET_FEE_STRUCTURE = 'set_fee_structure';
export const SET_BULK_DISCOUNT = 'set_bulk_discount';
export const SET_DISPENSARY_PRODUCTS = 'set_dispensary_products';
export const SET_DELIVERY_ADDRESS = 'set_delivery_address';
export const SET_ANON_USER_ZIP_CODE = 'set_anonymous_user_zip_code';
export const ADD_TO_CART = 'add_to_cart';
export const REMOVE_ITEM = 'remove_from_cart';
export const SUB_QUANTITY = 'reduce_item_quantity';
export const ADD_QUANTITY = 'increase_item_quantity';
export const SET_DELIVERY_WINDOW = 'set_delivery_window';
export const SET_PICKUP_TIME_SLOT = 'set_pickup_time_slot';
export const SET_IS_PICKUP = 'set_is_pickup';
export const SET_ORDER_HISTORY = 'set_order_history';
